import {
  DEFAULT_REPORT_ITEM_FORMAT_TYPE,
  formatReportValue, getTemplateRowFormatType,
} from '~/exportReport/formatting/exportReportFormatting.helpers';
import type { ExportReportTableValue } from '~/exportReport/table/ReportTable.model';
import type { ReportTemplateDataRow } from '~/exportReport/template/reportTemplate';
import {
  getReportTemplateDataRowDemographicId, type ReportDemographicData,
} from '../exportReportData.helpers';

const REPORT_VALUE_NOT_AVAILABLE = {
  value: 'N/A',
  isError: true,
} as const;

type GetDemographicData = (columnId: string, demographicId: string) => ReportDemographicData | null;

export const getDemographicTableCellValue = ({
  columnId, templateRow, getDemographicData,
}: Readonly<{
  columnId: string;
  templateRow: ReportTemplateDataRow;
  getDemographicData: GetDemographicData;
}>): ExportReportTableValue => {
  const demographicId = getReportTemplateDataRowDemographicId(templateRow);
  const demographicValue = getFetchedDemographicValue({ columnId, demographicId, getDemographicData });
  const demographicData = getDemographicData(columnId, demographicId);

  if (!demographicData) {
    return REPORT_VALUE_NOT_AVAILABLE;
  }

  const unit = templateRow.unit ?? '';
  const formatType = templateRow.format_type ? getTemplateRowFormatType(templateRow.format_type) : DEFAULT_REPORT_ITEM_FORMAT_TYPE;
  const formattedValue = formatReportValue({ value: demographicValue, formatType, unit });

  return {
    value: formattedValue,
  };
};

const getFetchedDemographicValue = ({ columnId, demographicId, getDemographicData }: Readonly<{
  columnId: string;
  demographicId: string;
  getDemographicData: GetDemographicData;
}>): number | string | null => {
  const demographicData = getDemographicData(columnId, demographicId);
  if (!demographicData || demographicData.value === null) {
    return null;
  }

  return demographicData.value;
};
